<template>
  <div class="LegalNotice page">
    <h1>Impressum</h1>
    <h2>Angaben gemäß § 5 TMG:</h2>
    <p>Berit Strathemann<br> Zahnarztpraxis<br> Mühlenstraße 13 – 15<br> 03130 Spremberg</p>
    <h2>Kontakt:</h2>
    <p>Telefon: 03563 601106<br> E-Mail: zahnarzt@strathemann.de</p>
    <h2>Berufsbezeichnung und berufsrechtliche Regelungen</h2>
    <p>
      Berufsbezeichnung: Zahnärzte<br> 
    </p>
    <h3>Zuständige Aufsichtsbehörde:</h3>
    <p>
      KZV Land Brandenburg<br>
      Helene-Lange-Str. 4 – 5<br>
      14469 Potsdam<br>
      Telefon: 0331 29770<br>
      Telefax: 0331 2977318
    </p>
    <h3>Zuständige Zahnärztekammer:</h3>
    <p>
      Landeszahnärztekammer Land Brandenburg<br>
      Parzellenstr. 94<br>
      03046 Cottbus<br>
      Telefon: 0355 480<br>
      Telefax: 0355 4848<br>
      info@lzkb.de<br>
      <a href="https://www.lzkb.de" rel="noindex nofollow noopener">www.lzkb.de</a>
    
    </p>

    <h2>Streitschlichtung</h2>
    <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
    <h2>Haftung für Inhalte</h2>
    <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
    <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
    <h2>Haftung für Links</h2>
    <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
    <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
    <h2>Urheberrecht</h2>
    <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
    <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
    <p>Quelle: <a href="https://www.erecht24. de/impressum-generator.html">https://www.e-recht24.de/impressum-generator.html</a></p>
    <v-divider class="my-5"></v-divider>
    <p>
      <strong>Konzept. Design. Umsetzung.</strong>
    </p>
    <p>
      chairlines medienagentur<br>
      Friedrichstraße 39<br>
      03130 Spremberg<br>
      03563 6080689<br>
      info@chairlines.de<br>
      <a href="https://www.chairlines.de">www.chairlines.de</a>
    </p>
  </div>
</template>

<script>
export default {
  components: {},
}
</script>
